import script from "./Train.vue?vue&type=script&setup=true&lang=js"
export * from "./Train.vue?vue&type=script&setup=true&lang=js"

import "./Train.vue?vue&type=style&index=0&id=5de373b7&lang=scss&scoped=true"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de373b7"]])

export default __exports__